<div
  class="calendar-filter-group"
  [class.is-between]="getDateFilterSelectionMode(field) === 'range'"
>
  <span class="operator-addon" (click)="dropdown.show($event)">
    {{
      dateFilterOperators[field]?.symbol || dateFilterOperatorOptions[0].symbol
    }}
  </span>

  <p-dropdown
    #dropdown
    [options]="dateFilterOperatorOptions"
    [ngModel]="dateFilterOperators[field] || dateFilterOperatorOptions[0]"
    (ngModelChange)="onDateOperatorChange($event, field)"
    [showClear]="false"
    optionLabel="symbol"
    appendTo="body"
    styleClass="operator-dropdown"
    [style]="{ position: 'absolute', visibility: 'hidden' }"
  >
    <ng-template let-option pTemplate="item">
      <span style="font-weight: bold; margin-right: 0.5rem">{{
        option.symbol
      }}</span>
      <span>{{ option.label }}</span>
    </ng-template>
  </p-dropdown>

  <div class="calendar-wrapper">
    <p-calendar
      [(ngModel)]="selectedDate"
      (onSelect)="dateSelectedField = field"
      dateFormat="dd/mm/yy"
      [placeholder]="'Select date' | translate"
      [showIcon]="true"
      icon="fas fa-calendar-alt"
      appendTo="body"
      [selectionMode]="getDateFilterSelectionMode(field)"
      [showButtonBar]="true"
      [showClear]="clearButton"
      (onClear)="onDateInput(null, field)"
    />

    <!-- Two-line overlay for between mode -->
    <div
      *ngIf="getDateFilterSelectionMode(field) === 'range' && selectedDateRange"
      class="range-display"
    >
      <span>{{ formatShortDate(selectedDateRange[0]) }}</span>
      <span>{{ formatShortDate(selectedDateRange[1]) }}</span>
    </div>
  </div>
</div>
